<template>
  <div class="ibox">

    <div class="ibox-title" :class="classHeader">
      <slot name="header"/>
    </div>

    <div class="ibox-content" :class="classBody">
      <slot/>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'Card',
    props: {
      classBody: {required: false, type: Object},
      classHeader: {required: false, type: Object},
    }
  }
</script>

<style scoped>

</style>
